module.exports = __webpack_public_path__ + "img/paperPlane.9a12bf36.png";